/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import AbstractSlider from './AbstractSlider';
import AuthModal from './AuthModal';
import CountryRedirectModal from './CountryRedirectModal';
import CustomFooter from './CustomFooter';
import DiscussionSkeleton from './DiscussionSkeleton';
import ExpandableContent from './ExpandableContent';
import FollowingFilterDropdown from './FollowingFilterDropdown';
import HomeActivityLeaderboard from './HomeActivityLeaderboard';
import HomeCategories from './HomeCategories';
import HomeDiscussions from './HomeDiscussions';
import HomePage from './HomePage';
import HomeWelcome from './HomeWelcome';
import LinkedAccounts from './LinkedAccounts';
import LoadingPage from './LoadingPage';
import MobileTour from './MobileTour';
import MobileTourCard from './MobileTourCard';
import MobileTourStepModal from './MobileTourStepModal';
import PostActivityLeaderItem from './PostActivityLeaderItem';
import RedirectHome from './RedirectHome';
import Separator from './Separator';
import SignUpAlertBody from './SignUpAlertBody';
import TourProgress from './TourProgress';
import TourStepBody from './TourStepBody';

export const components = {
	AbstractSlider,
	AuthModal,
	CountryRedirectModal,
	CustomFooter,
	DiscussionSkeleton,
	ExpandableContent,
	FollowingFilterDropdown,
	HomeActivityLeaderboard,
	HomeCategories,
	HomeDiscussions,
	HomePage,
	HomeWelcome,
	LinkedAccounts,
	LoadingPage,
	MobileTour,
	MobileTourCard,
	MobileTourStepModal,
	PostActivityLeaderItem,
	RedirectHome,
	Separator,
	SignUpAlertBody,
	TourProgress,
	TourStepBody,
};
